var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusInRhombus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82843 9.17194L9.17157 2.8288C10.7337 1.2667 13.2663 1.2667 14.8284 2.8288L21.1716 9.17194C22.7337 10.734 22.7337 13.2667 21.1716 14.8288L14.8284 21.1719C13.2663 22.734 10.7337 22.734 9.17157 21.1719L2.82842 14.8288C1.26633 13.2667 1.26633 10.734 2.82843 9.17194Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2322 3.88946L3.88909 10.2326C2.91278 11.2089 2.91277 12.7918 3.88908 13.7681L10.2322 20.1113C11.2085 21.0876 12.7915 21.0876 13.7678 20.1113L20.1109 13.7681C21.0872 12.7918 21.0872 11.2089 20.1109 10.2326L13.7678 3.88946C12.7915 2.91315 11.2085 2.91315 10.2322 3.88946ZM9.17157 2.8288L2.82843 9.17194C1.26633 10.734 1.26633 13.2667 2.82842 14.8288L9.17157 21.1719C10.7337 22.734 13.2663 22.734 14.8284 21.1719L21.1716 14.8288C22.7337 13.2667 22.7337 10.734 21.1716 9.17194L14.8284 2.8288C13.2663 1.2667 10.7337 1.2667 9.17157 2.8288Z",
    fill: "#56777F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.75C12.4142 6.75 12.75 7.08579 12.75 7.5V11.25H16.5C16.9142 11.25 17.25 11.5858 17.25 12C17.25 12.4142 16.9142 12.75 16.5 12.75H12.75V16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5V12.75H7.5C7.08579 12.75 6.75 12.4142 6.75 12C6.75 11.5858 7.08579 11.25 7.5 11.25H11.25V7.5C11.25 7.08579 11.5858 6.75 12 6.75Z",
    fill: "#56777F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusInRhombus);
export default __webpack_public_path__ + "static/media/plus_in_rhombus.b19f922059e477fa755b9202a9d6497f.svg";
export { ForwardRef as ReactComponent };